import zhCN from './zh-cn'
import enUS from './en-us'
import zhTw from './zh-tw'

export const captchaLocales = {
    zh: { captcha: zhCN },
    cn: { captcha: zhCN },
    'zh-cn': { captcha: zhCN },
    'en-us': { captcha: enUS },
    'zh-tw': { captcha: zhTw }
}
